import {createClient} from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'


// 1) Create and export the client
export const client = createClient({
  projectId: 'kptun2pd',
  dataset: 'production',
  useCdn: false,
  token: 'skEACBEH2N4l1cJS2ma1Pxi6p8w2HTMMOiB5OcPbFOQxTtMOT7d5n4MSW7LmuSDnSJqIc0dxCdWLhdkDIqFlJopoIM2wWkdloUtd7bIj4ifM5Ghm8nD9zyOZvbxolGxWx6aHAcTqujiGVSFrFxaRoG5vUHPfUvGciaKtZJCK3DICM42rc5zJ',                      // or leave blank for unauthenticated usage
})

// 2) Create and export a helper for generating image URLs
const builder = imageUrlBuilder(client)

export function urlFor(source) {
  return builder.image(source)
}